export default function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    let r = false;
    s.type = 'text/javascript';
    s.src = src;
    s.id = id;
    s.onerror = function (err) {
      // @ts-ignore
      reject(err, s);
    };
    // eslint-disable-next-line no-multi-assign
    s.onload = s.onreadystatechange = function () {
      // console.log(this.readyState); // uncomment this line to see which ready states are called.
      // @ts-ignore
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true;
        // @ts-ignore
        resolve();
      }
    };
    const t = document.getElementsByTagName('script')[0];
    // @ts-ignore
    t.parentElement.insertBefore(s, t);
  });
}
